import type { MonthRecord } from '../domain/types';

export const availableYears = (months: MonthRecord[]) =>
  [...new Set(months.map(({ month }) => month.slice(0, 4)))].sort();

export const YearSelector = ({
  months,
  value,
  onChange,
}: {
  months: MonthRecord[];
  value: string;
  onChange: (year: string) => void;
}) => (
  <label className="year-selector">
    <span>12-month view</span>
    <select value={value} onChange={(event) => onChange(event.target.value)}>
      {availableYears(months).map((year) => <option key={year} value={year}>{year}</option>)}
    </select>
  </label>
);
